// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Two panels per row, matching the Meta and Google report rows. */
.platform-report__two-col {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.platform-report__two-col > .paid-media-panel {
  margin-bottom: 16px;
}

@media (max-width: 1023px) {
  .platform-report__two-col {
    grid-template-columns: 1fr;
  }
}
/* Trend chip dots use the shared metric palette, matching the Meta and Google
 * reports without inline styles. */
.platform-report-trend-dot--spend {
  background-color: #2b74e4;
}

.platform-report-trend-dot--impressions {
  background-color: #36cdb0;
}

.platform-report-trend-dot--clicks {
  background-color: #f6c15f;
}

.platform-report-trend-dot--purchases {
  background-color: #8d4fd3;
}

/* Performance Trends — widen plot gutter so dual Y-axis labels are not clipped. */
.platform-report__trends-chart {
  margin-inline: -14px;
  width: calc(100% + 28px);
  max-width: calc(100% + 28px);
}
.platform-report__trends-chart .recharts-responsive-container,
.platform-report__trends-chart .recharts-wrapper {
  overflow: visible;
}

@media (max-width: 1023px) {
  .platform-report__trends-chart {
    margin-inline: -8px;
    width: calc(100% + 16px);
    max-width: calc(100% + 16px);
  }
}
@media (max-width: 640px) {
  .platform-report__trends-chart {
    margin-inline: 0;
    width: 100%;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/paidMedia/components/platformReport/PlatformAdsReport.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kEAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE;IACE,0BAAA;EAEF;AACF;AACA;mCAAA;AAUE;EACE,yBAT2B;AAE/B;;AAME;EACE,yBAT2B;AAM/B;;AAEE;EACE,yBAT2B;AAU/B;;AAFE;EACE,yBAT2B;AAc/B;;AADA,kFAAA;AACA;EACE,oBAAA;EACA,wBAAA;EACA,4BAAA;AAIF;AAFE;;EAEE,iBAAA;AAIJ;;AAAA;EACE;IACE,mBAAA;IACA,wBAAA;IACA,4BAAA;EAGF;AACF;AAAA;EACE;IACE,gBAAA;IACA,WAAA;IACA,eAAA;EAEF;AACF","sourcesContent":["/* Two panels per row, matching the Meta and Google report rows. */\n.platform-report__two-col {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.platform-report__two-col > .paid-media-panel {\n  margin-bottom: 16px;\n}\n\n@media (max-width: 1023px) {\n  .platform-report__two-col {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Trend chip dots use the shared metric palette, matching the Meta and Google\n * reports without inline styles. */\n$platform-report-trend-colors: (\n  \"spend\": #2b74e4,\n  \"impressions\": #36cdb0,\n  \"clicks\": #f6c15f,\n  \"purchases\": #8d4fd3,\n);\n\n@each $metric, $color in $platform-report-trend-colors {\n  .platform-report-trend-dot--#{$metric} {\n    background-color: $color;\n  }\n}\n\n/* Performance Trends — widen plot gutter so dual Y-axis labels are not clipped. */\n.platform-report__trends-chart {\n  margin-inline: -14px;\n  width: calc(100% + 28px);\n  max-width: calc(100% + 28px);\n\n  .recharts-responsive-container,\n  .recharts-wrapper {\n    overflow: visible;\n  }\n}\n\n@media (max-width: 1023px) {\n  .platform-report__trends-chart {\n    margin-inline: -8px;\n    width: calc(100% + 16px);\n    max-width: calc(100% + 16px);\n  }\n}\n\n@media (max-width: 640px) {\n  .platform-report__trends-chart {\n    margin-inline: 0;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
